import { Box } from '@mui/material';
import {
  MyAbsencesWidget,
  WhosAwayList,
} from '../../dashboard-widgets';
import type {
  AwayScope,
  MyAbsenceItem,
  TeamAbsenceThisWeekItem,
} from '../../dashboard-widgets/types';

interface AvailabilitySectionProps {
  myAbsences: MyAbsenceItem[] | undefined;
  teamAbsencesThisWeek: TeamAbsenceThisWeekItem[] | undefined;
  /** Which population `teamAbsencesThisWeek` describes — never inferred (AC-40). */
  awayScope: AwayScope | undefined;
  loading?: boolean;
  onSeeAllTeamAbsences?: () => void;
}

/**
 * `Availability` section — prototype port. 2-up grid (1fr / 1fr):
 *   - LEFT  : `MyAbsencesWidget` (own upcoming leave / sickness)
 *   - RIGHT : `WhosAwayList` (top-5 team absences this week + see-all)
 *
 * Section gate: always-on.
 */
export function AvailabilitySection({
  myAbsences,
  teamAbsencesThisWeek,
  awayScope,
  loading,
  onSeeAllTeamAbsences,
}: AvailabilitySectionProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) minmax(0, 1fr)' },
        gap: 2,
        alignItems: 'start',
      }}
    >
      <MyAbsencesWidget items={myAbsences} loading={loading} />
      <WhosAwayList
        items={teamAbsencesThisWeek}
        scope={awayScope}
        loading={loading}
        onSeeAll={onSeeAllTeamAbsences}
      />
    </Box>
  );
}
